import { z } from "zod";

export const idempotencyKeySchema = z.uuid();

const employeeSkillCommand = z
  .object({
    employeeId: z.string().min(1),
    skillId: z.string().min(1),
  })
  .strict();

export const prototypeCommandSchema = z.discriminatedUnion("type", [
  employeeSkillCommand.extend({ type: z.literal("assessment_started") }),
  employeeSkillCommand.extend({
    type: z.literal("assessment_completed"),
    answers: z.array(z.number().int().nonnegative()),
  }),
  employeeSkillCommand.extend({ type: z.literal("training_started") }),
  employeeSkillCommand.extend({ type: z.literal("training_completed") }),
  employeeSkillCommand.extend({
    type: z.literal("test_completed"),
    answers: z.array(z.number().int().nonnegative()),
  }),
  employeeSkillCommand.extend({
    type: z.literal("supervisor_decision"),
    decision: z.enum(["confirm", "keep", "deny"]),
    feedback: z.string().optional(),
  }),
  z
    .object({
      type: z.literal("onboarding_completed"),
      employeeId: z.string().min(1),
      roleId: z.string().min(1),
      workContext: z.string().min(2),
    })
    .strict(),
  z
    .object({
      type: z.literal("theme_set"),
      themeId: z.enum(["peer-start", "peer-start-warm"]),
    })
    .strict(),
  z.object({ type: z.literal("prototype_reset") }).strict(),
]);

export const commandResultSchema = z.object({
  ok: z.literal(true),
  message: z.string().min(1),
});

export const errorResponseSchema = z.object({
  error: z.string().min(1),
  details: z.array(z.string()).optional(),
});

export const authErrorResponseSchema = errorResponseSchema.extend({
  code: z.enum(["forbidden", "unauthenticated"]),
});

export type PrototypeCommand = z.infer<typeof prototypeCommandSchema>;
export type CommandResult = z.infer<typeof commandResultSchema>;
